import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./UserListPage.scss";
import CustomDataTable from "../../../components/CustomDataTable";

function UserListPage() {
  const [name, setName] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const ref = useRef();

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsPopupVisible(true);
  };

  function confirmDelete() {
    console.log(`Confirmed delete for ID: ${selectedId}`);
    ref.current?.refresh();
    setIsPopupVisible(false);
    setSelectedId(null);
  }

  function closePopup() {
    setIsPopupVisible(false);
    setSelectedId(null);
  }

  const columns = [
    {
      name: "Utilizator",
      selector: (row) => row.username,
    },
    {
      name: "Nume",
      selector: (row) => row.name,
    },
    {
      name: "Organizaţie",
      selector: (row) => row.organization,
    },
    {
      name: "Acţiuni",
      cell: (row) => (
        <div className="action-buttons">
          <button
            onClick={() => handleDelete(row.id)}
            className="delete-button"
          >
            <img src="../images/delete.png" alt="Delete" className="icon" />
          </button>
          <Link
            to={`/dashboard/user/edit/${row.id}`}
            state={{ user: row }}
            className="edit-button"
          >
            <img src="../images/edit.png" alt="Edit" className="icon-small" />
          </Link>

        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  function handleSearch() {
    ref.current?.refresh();
  }

  function setSearchName(e) {
    setName(e.target.value);
  }

  return (
    <div className="user-list-page">
      <div className="my-4 d-flex justify-content-center gap-2">
        <input
          type="search"
          className="px-4 py-2 w-50 text-black rounded"
          placeholder="Căutare..."
          onChange={setSearchName}
        />

        <button
          onClick={handleSearch}
          className="px-4 py-2 text-white rounded btn"
        >
          Căutare
        </button>
      </div>

      <div className="table-wrapper">
        <CustomDataTable
          columns={columns}
          title="Conturi"
          fetchUrl="/api/User/Search"
          filters={{ name: name }}
          ref={ref}
        />
      </div>

      {isPopupVisible && (
        <div className="popup">
          <div className="confirm p-3 rounded">
            <p className="mb-4 popupText fw-bold">Ești sigur că vrei să ștergi această înregistrare?</p>
            <div className="d-flex justify-content-end gap-4">
              <button onClick={confirmDelete} className="px-4 py-2 rounded btnPopup">Da</button>
              <button onClick={closePopup} className="px-4 py-2 rounded btnPopup">Nu</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserListPage;
